import * as React from 'react';
import { TvGuideView } from '~source/core/models/tv-guide';
import $ from './view-toggle.scss';

export interface ViewToggleProps {
    currentView: TvGuideView;
    onViewChange: (view: TvGuideView) => void;
}

const views: { value: TvGuideView; label: string }[] = [
    { value: 'list', label: 'Lijst' },
    { value: 'timeline', label: 'Tijdlijn' },
    { value: 'live', label: 'Live' },
];

export const ViewToggle: React.FC<ViewToggleProps> = ({ currentView, onViewChange }) => (
    <div className={$.wrap} role='group' aria-label='Weergave'>
        {views.map((view) => (
            <button
                key={view.value}
                type='button'
                className={$.option}
                aria-pressed={currentView === view.value}
                onClick={() => onViewChange(view.value)}
            >
                <span className={$.label}>{view.label}</span>
            </button>
        ))}
    </div>
);
